import React from "react";

const Loading = () => <div className="loader m-auto h-16 w-16" />;

export default Loading;